module.exports = __webpack_public_path__ + "static/media/bbqempty.558e4cce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/history-icons/bbqempty.svg
// module id = 833
// module chunks = 0